import { render, staticRenderFns } from "./workloadSkeleton.vue?vue&type=template&id=b6bf5940&"
import script from "./workloadSkeleton.vue?vue&type=script&lang=js&"
export * from "./workloadSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./workloadSkeleton.vue?vue&type=style&index=0&module=%24&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./workloadSkeleton.vue?vue&type=style&index=0&module=%24&lang=less&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("./workloadSkeleton.vue?vue&type=style&index=0&module=%24&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("b6bf5940")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6bf5940')) {
      api.createRecord('b6bf5940', component.options)
    } else {
      api.reload('b6bf5940', component.options)
    }
    module.hot.accept("./workloadSkeleton.vue?vue&type=template&id=b6bf5940&", function () {
      api.rerender('b6bf5940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/main/workloadPage/workloadSkeleton.vue"
export default component.exports